var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"coupon-list-container"},_vm._l(((_vm.listData)),function(item,index){return _c('div',{key:item.index},[_c('coupon-item',{attrs:{"couponData":(item),"couponTheme":(_vm.couponTheme)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }